export const PRIORITIES = {
  1: { label: "Kritiek", short: "Prio 1", hex: "#DC2626", bg: "#FEF2F2", border: "#FCA5A5", text: "#991B1B" },
  2: { label: "Hoog", short: "Prio 2", hex: "#EA580C", bg: "#FFEDD5", border: "#FED7AA", text: "#9A3412" },
  3: { label: "Middel", short: "Prio 3", hex: "#D97706", bg: "#FFFBEB", border: "#FDE68A", text: "#92400E" },
  4: { label: "Laag", short: "Prio 4", hex: "#059669", bg: "#ECFDF5", border: "#A7F3D0", text: "#065F46" },
};

export const VEHICLE_STATUSES = {
  beschikbaar: { label: "Beschikbaar", hex: "#16A34A", bg: "#F0FDF4", border: "#BBF7D0", text: "#166534" },
  gealarmeerd: { label: "Gealarmeerd", hex: "#E11D48", bg: "#FFF1F2", border: "#FECDD3", text: "#9F1239" },
  uitgerukt: { label: "Uitgerukt", hex: "#2563EB", bg: "#EFF6FF", border: "#BFDBFE", text: "#1E40AF" },
  ter_plaatse: { label: "Ter plaatse", hex: "#D97706", bg: "#FFFBEB", border: "#FDE68A", text: "#92400E" },
  retour_kazerne: { label: "Retour kazerne", hex: "#9333EA", bg: "#FAF5FF", border: "#E9D5FF", text: "#6B21A8" },
  buiten_dienst: { label: "Buiten dienst", hex: "#64748B", bg: "#F8FAFC", border: "#E2E8F0", text: "#334155" },
};

export const STATUS_ORDER = ["beschikbaar", "gealarmeerd", "uitgerukt", "ter_plaatse", "retour_kazerne", "buiten_dienst"];

export const ROLE_LABELS = {
  beheerder: "Beheerder",
  meldkamer: "Meldkamer",
  voertuig: "Voertuig",
};

export function timeAgo(iso) {
  if (!iso) return "";
  const d = new Date(iso);
  const diff = Math.floor((Date.now() - d.getTime()) / 1000);
  if (diff < 60) return `${diff}s geleden`;
  if (diff < 3600) return `${Math.floor(diff / 60)}m geleden`;
  if (diff < 86400) return `${Math.floor(diff / 3600)}u geleden`;
  return d.toLocaleString("nl-NL", { day: "2-digit", month: "short", hour: "2-digit", minute: "2-digit" });
}

export function fmtTime(iso) {
  if (!iso) return "—";
  return new Date(iso).toLocaleString("nl-NL", { day: "2-digit", month: "2-digit", hour: "2-digit", minute: "2-digit" });
}

export function fmtMinutes(min) {
  if (!min || min <= 0) return "—";
  if (min < 60) return `${min} min`;
  const h = Math.floor(min / 60);
  const m = min % 60;
  return `${h}u ${m}m`;
}

// Compute the current dienst (shift) window based on start/end "HH:MM".
export function shiftWindow(startHM = "08:00", endHM = "08:00", ref = new Date()) {
  const [sh, sm] = startHM.split(":").map(Number);
  const [eh, em] = endHM.split(":").map(Number);
  const start = new Date(ref);
  start.setHours(sh, sm, 0, 0);
  if (ref < start) start.setDate(start.getDate() - 1);
  const end = new Date(start);
  end.setHours(eh, em, 0, 0);
  if (end <= start) end.setDate(end.getDate() + 1);
  return [start, end];
}

// Range presets -> [fromDate, toDate]
export function rangeFor(mode, shift, custom) {
  const now = new Date();
  if (mode === "dienst") return shiftWindow(shift?.start, shift?.end, now);
  if (mode === "week") {
    const d = new Date(now);
    const day = (d.getDay() + 6) % 7; // Monday = 0
    const start = new Date(d); start.setDate(d.getDate() - day); start.setHours(0, 0, 0, 0);
    const end = new Date(start); end.setDate(start.getDate() + 7);
    return [start, end];
  }
  if (mode === "maand") {
    const start = new Date(now.getFullYear(), now.getMonth(), 1, 0, 0, 0, 0);
    const end = new Date(now.getFullYear(), now.getMonth() + 1, 1, 0, 0, 0, 0);
    return [start, end];
  }
  if (mode === "custom" && custom?.from && custom?.to) {
    const start = new Date(custom.from + "T00:00:00");
    const end = new Date(custom.to + "T23:59:59");
    return [start, end];
  }
  return shiftWindow(shift?.start, shift?.end, now);
}

export function fmtRangeLabel(mode, shift, custom) {
  const [a, b] = rangeFor(mode, shift, custom);
  const opt = { day: "2-digit", month: "2-digit", hour: "2-digit", minute: "2-digit" };
  return `${a.toLocaleString("nl-NL", opt)} — ${b.toLocaleString("nl-NL", opt)}`;
}
